import React from 'react';

// Shown while a work order, estimate or invoice loads: the sheet's outline.
export const DocSkeleton = ({ noun = 'document' }) => (
  <div className="de cp--loading" role="status" aria-label={`Loading ${noun}`}>
    <div className="de-toolbar" aria-hidden="true">
      <span className="dl-bone" style={{ width: 200, height: 30, borderRadius: 999 }} />
      <span className="dl-bone" style={{ width: 300, height: 32, borderRadius: 8 }} />
    </div>
    <div className="de-sheet" aria-hidden="true">
      <div className="de-letterhead">
        <span className="dl-bone" style={{ width: 140, height: 48 }} />
        <span className="dl-bone" style={{ width: 180, height: 60 }} />
      </div>
      <span className="dl-bone" style={{ width: 280, height: 30, marginTop: 28 }} />
      <span className="dl-bone" style={{ width: '100%', height: 90, marginTop: 24 }} />
      {[0, 1, 2].map((index) => <span key={index} className="dl-bone" style={{ width: '100%', height: 56, marginTop: 16 }} />)}
    </div>
  </div>
);

export default DocSkeleton;
